import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const SearchIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <circle className={classes.element} cx="11" cy="11.00001" r="9" />
      <line className={classes.element} x1="22" y1="22.00001" x2="17.3628" y2="17.36201" />
    </svg>
  );
};

export default SearchIcon;
